import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6.82508 3.90004C7.15645 4.14857 7.22361 4.61867 6.97508 4.95004L4.72508 7.95004C4.48625 8.26848 4.04025 8.34488 3.70905 8.12408L2.58405 7.37408C2.23941 7.14432 2.14628 6.67867 2.37604 6.33402C2.60581 5.98937 3.07146 5.89624 3.4161 6.12601L3.95077 6.48245L5.77508 4.05004C6.02361 3.71867 6.49371 3.65152 6.82508 3.90004ZM9.00008 6.00004C9.00008 5.58583 9.33587 5.25004 9.75008 5.25004H15.0001C15.4143 5.25004 15.7501 5.58583 15.7501 6.00004C15.7501 6.41426 15.4143 6.75004 15.0001 6.75004H9.75008C9.33587 6.75004 9.00008 6.41426 9.00008 6.00004ZM6.82508 9.90004C7.15645 10.1486 7.22361 10.6187 6.97508 10.95L4.72508 13.95C4.48625 14.2685 4.04025 14.3449 3.70905 14.1241L2.58405 13.3741C2.23941 13.1443 2.14628 12.6787 2.37604 12.334C2.60581 11.9894 3.07146 11.8962 3.4161 12.126L3.95077 12.4825L5.77508 10.05C6.02361 9.71867 6.49371 9.65152 6.82508 9.90004ZM9.00008 12C9.00008 11.5858 9.33587 11.25 9.75008 11.25H15.0001C15.4143 11.25 15.7501 11.5858 15.7501 12C15.7501 12.4143 15.4143 12.75 15.0001 12.75H9.75008C9.33587 12.75 9.00008 12.4143 9.00008 12Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }